import { usePortal } from '@web-ui-kit/hooks.use-portal'
import Snackbar from '@web-ui-kit/snackbar'
import { v4 as uuidv4 } from 'uuid'

import { Snackbar as SnackbarType } from 'shared/contexts/SnackbarContext'
import useMediaQuery from 'shared/hooks/useMediaQuery'

import * as Sc from './SnackbarFeedback.style'


type SnackbarFeedbackProps = {
  snackbars: SnackbarType[]
}

const SnackbarFeedback = ({ snackbars }: SnackbarFeedbackProps) => {
  const { isMobile } = useMediaQuery()
  const { render } = usePortal('snackbar-feedback')

  return render(
    <Sc.Container>
      {snackbars.map(({ text, type }) => (
        <Snackbar
          key={uuidv4()}
          size={isMobile ? 'small' : 'large'}
          text={text}
          type={type}
        />
      ))}
    </Sc.Container>,
  )
}

export default SnackbarFeedback
